import slugify from 'slugify';

let sLocale; let cleanContent; const buffer = {};
const baseUrl = INKIVE.C.IS_DEV
  ? INKIVE.C.BASE_URL + 'assets/build/swearing/swearing.'
  : 'https://static.inkive.com/assets/build/' + INKIVE.C.VERSION + '/swearing/swearing.';

const slugifyLocales = {
  ar: [],
  az: [],
  cs: [],
  de: ['de'],
  dv: [],
  en: ['en'],
  es: ['es'],
  fa: [],
  fr: ['fr'],
  gr: [],
  hu: [],
  it: ['it'],
  lt: [],
  lv: [],
  my: [],
  mk: [],
  nl: ['nl'],
  pl: [],
  pt: ['pt'],
  ro: [],
  ru: ['ru'],
  sk: [],
  sr: [],
  tr: [],
  uk: [],
  vn: []
};

module.exports = {
  matchSwearing: function (locales, content) {
    locales = _.isArray(locales) ? locales : [locales];

    return _.any(locales, function (locale) {
      sLocale = getSlugLocale(locale);
      cleanContent = clean(content);

      return _.any(buffer[locale], hasInsult);
    });
  },

  preloadSwearingLists: function (locales) {
    locales = _.isArray(locales) ? locales : [locales];

    const deferred = $.Deferred();
    const missing = _(locales).filter(function (locale) {
      return !buffer[locale];
    });

    if (missing.length) {
      $.when.apply($, _(missing).map(loadSwearingList)).then(function () {
        const results = _.toArray(arguments);
        _.each(missing, function (locale, index) {
          buffer[locale] = missing.length === 1
            ? results[0].badwords
            : results[index][0].badwords;
        });

        deferred.resolve();
      });
    } else {
      deferred.resolve();
    }

    return deferred.promise();
  }
};

function getSlugLocale (locale) {
  let sLocale;

  _.any(slugifyLocales, function (locales, index) {
    if (_(locales).contains(locale)) {
      sLocale = index;
      return sLocale;
    }

    return false;
  });

  return sLocale;
}

function hasInsult (insult) {
  return cleanContent.split('-').includes(clean(insult));
}

function clean (content) {
  return slugify(content, {
    remove: /[*+~.()'"!:@]/g,
    lower: true
  });
}

function loadSwearingList (locale) {
  return $.get(baseUrl + locale + '.json?' + INKIVE.C.VERSION);
}
